import type { FunctionComponent } from "react";

import { Container, StyledBaseLink, StyledTrustLogo } from "./styles";

export const ArticleTrustLabel: FunctionComponent = ({}) => (
  <Container>
    <StyledTrustLogo />

    <StyledBaseLink anchorProps={{ target: "_blank" }} pathname="/policies-and-standards">
      Why you can trust SCMP
    </StyledBaseLink>
  </Container>
);

ArticleTrustLabel.displayName = "ArticleTrustLabel";
